exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text_quiz__quality[data-v-71eb1040]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;flex-direction:column;margin-bottom:20px}.text_quiz__quality span[data-v-71eb1040]{color:#666;font-size:18px;margin-bottom:5px}", ""]);

// exports
